import React from 'react';
import classNames from 'classnames';
import {Nav, NavItem, NavLink, TabContent, TabPane} from 'reactstrap';

import styles from './Tabs.module.scss';

const CustomNavLink = (props) => {
  const {id, current, tabName, toggle, disabled} = props;

  const isActive = current === id;

  return (
    <NavItem className={styles[isActive ? 'nav-item--active' : 'nav-item']}>
      <NavLink
        disabled={disabled}
        onClick={() => toggle(id)}
        style={{cursor: 'pointer', userSelect: 'none'}}
        className={classNames(
          styles[isActive ? 'nav-item__text--active' : 'nav-item__text'],
          'text-nowrap'
        )}
      >
        {tabName}
      </NavLink>
    </NavItem>
  );
};

function Tabs(props) {
  const {toggle, active, tabs, disabled, navClassname, tabClassname} = props;

  return (
    <>
      <Nav
        tabs
        tag="nav"
        className={classNames('flex-nowrap p-0', navClassname)}
        style={{overflowX: 'auto', whiteSpace: 'nowrap', overflowY: 'hidden'}}
      >
        {tabs.map((tab) => {
          const {key, tabName} = tab;

          return (
            <CustomNavLink
              disabled={disabled}
              key={key}
              id={key}
              toggle={toggle}
              current={active}
              tabName={tabName}
            />
          );
        })}
      </Nav>

      <TabContent activeTab={active} className={tabClassname}>
        {tabs.map((tab) => {
          const {key, children} = tab;

          return (
            <TabPane tabId={key} key={key}>
              {children}
            </TabPane>
          );
        })}
      </TabContent>
    </>
  );
}

export default Tabs;
